/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:100%;flex-basis:100%;padding-top:20px;min-width:600px;height:100%}.description[_ngcontent-%COMP%]{margin-bottom:35px}textarea[_ngcontent-%COMP%]{min-height:200px}input[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{font-size:13px}"];
export { styles as styles };



// WEBPACK FOOTER //
// /app/src/app/settings/components/report-email-settings/report-email-settings.component.scss.shim.ngstyle.js.pre-build-optimizer.js